import { getOrderBadge } from "@/api/common";
import { onMounted, ref } from "vue";

/* 处理订单角标 */
const orderBadge = ref({
  orderManager: 0, // 订单管理
  afterSaleOrder: 0, // 售后订单
  exceptionSaleOrder: 0, // 异常订单
  complaintOrder: 0, // 客诉订单
  collectionOrder: 0, // 催收订单
});
export const useOrderBadge = () => {
  
  onMounted(async () => {
    refreshOrderBadge();
  });

  const refreshOrderBadge = async () => {
    let {
      error,
      result: { data },
    } = await getOrderBadge();
    if (!error) {
      // orderBadge.value = data;
      orderBadge.value.orderManager = data.all_count
      orderBadge.value.afterSaleOrder = data.refund_count
      orderBadge.value.exceptionSaleOrder = data.except_count
      orderBadge.value.complaintOrder = data.wx_count
      orderBadge.value.collectionOrder = data.collection_count
    }
  };

  return { orderBadge, refreshOrderBadge };
};
